module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper contact"
  }, [_c('c-map'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', {
    staticClass: "contact__addresses"
  }, _vm._l((_vm.document.contact_section_repeater), function(item) {
    return _c('div', {
      staticClass: "contact__address",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })
  }))])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df917ab6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contact.vue
// module id = 281
// module chunks = 0